import PropTypes from 'prop-types';
import React from 'react';
import { CheckboxComponent } from './InputStyles';
import { Checkbox } from 'antd';

const DefaultCheckbox = ({ label, input, meta, secondary }) => {
  const showError = meta && (meta.invalid && meta.submitFailed);
  return (
    <CheckboxComponent secondary={secondary} error={showError}>
      <Checkbox {...input}>{label}</Checkbox>
    </CheckboxComponent>
  );
};

DefaultCheckbox.propTypes = {
  input: PropTypes.object.isRequired,
  inputLabelProps: PropTypes.object
};

export default DefaultCheckbox;



// WEBPACK FOOTER //
// ./src/components/Inputs/DefaultCheckbox.js